<template>
  <v-row>
    <v-col md="4" cols="12">
      <v-select
        v-if="discoveryType !== 'stackedArea'"
        :value="compareId"
        :items="scans"
        class="scan-list"
        item-value="entity_id"
        label="Discovery Profiles"
        item-text="scan_start_time"
        attach
        hide-details
        :menu-props="{ offsetY: true }"
        :loading="isLoadingScans || loading"
        :disabled="isLoadingScans || isLoadingAnalysis || !scans.length || loading"
      >
        <template slot="selection" slot-scope="data">
          <span v-if="data.item.entity_id && data.item.entity_id == 'last_24_hours'">
            {{ data.item.value }}
          </span>
          <span v-else>
            <span v-if="data.item.collector_id && getCollectorName(data.item.collector_id)" class="mr-1"
              >[{{ getCollectorName(data.item.collector_id) }}]</span
            >
            <span v-if="data.item.scan_start_time">{{ getFormattedDateTime(data.item.scan_start_time) }}</span> ({{
              format(data.item.total_files)
            }}
            Files)
          </span>
        </template>
        <template slot="item" slot-scope="data">
          <span
            class="scan-list--item"
            v-if="data.item.entity_id && data.item.entity_id == 'last_24_hours'"
            @click="handleOptionClick($event, data.item, 'from')"
          >
            {{ data.item.value }}
          </span>
          <span class="scan-list--item" @click="handleOptionClick($event, data.item, 'from')" v-else>
            <span
              ><span v-if="data.item.collector_id && getCollectorName(data.item.collector_id)" class="mr-1"
                >[{{ getCollectorName(data.item.collector_id) }}]</span
              >
              <span v-if="data.item.scan_start_time">{{ getFormattedDateTime(data.item.scan_start_time) }}</span> ({{
                format(data.item.total_files)
              }}
              Files)</span
            >
          </span>
        </template>
      </v-select>
      <!-- Time series collector dropdown -->
      <v-select
        v-else
        v-model="selectedCollectors"
        :items="getSortedCollectors"
        class="scan-list"
        item-value="entity_id"
        label="Collectors"
        item-text="name"
        attach
        hide-details
        multiple
        :menu-props="{ offsetY: true }"
      >
        <template slot="selection" slot-scope="data">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-chip
                v-bind="data.attrs"
                :input-value="data.selected"
                close
                @click="data.select"
                @click:close="removeCollector(data.item)"
                v-on="on"
              >
                <div>
                  <span class="mr-1">[{{ data.item.name }}]</span>
                </div>
              </v-chip>
            </template>
            <div>
              <span class="mr-1">[{{ data.item.name }}]</span>
            </div>
          </v-tooltip>
        </template>
        <template v-if="collectors.length" slot="append-item">
          <div v-if="isCollectorsSelect" class="select-all" @click="selectCollectors(false)">Unselect All</div>
          <div v-else class="select-all" @click="selectCollectors(true)">Select All</div>
        </template>
        <template slot="item" slot-scope="data">
          <div class="scan-list--inner-item">
            <v-checkbox class="checkbox rounded-circle" color="#3ACA56" :input-value="isCollectorChecked(data.item)"> </v-checkbox>
            <div style="width: 100%">
              <div class="item-name">
                <span v-if="data.item.name" class="mr-1">[{{ data.item.name }}]</span>
              </div>
            </div>
          </div>
        </template>
      </v-select>
    </v-col>
    <v-col
      md="4"
      cols="12"
      v-if="!(selectedScan && selectedScan.entity_id && selectedScan.entity_id === 'last_24_hours')"
    >
      <v-select
        :value="selectedDrives"
        :items="scan.drives"
        class="scan-list"
        item-value="name"
        item-text="completed_on"
        :label="scan.drives.length ? 'Select Drives' : 'All'"
        attach
        chips
        :multiple="true"
        no-data-text="All"
        hide-details
        :menu-props="{ offsetY: true }"
        :loading="isLoadingScans"
        :disabled="isLoadingScans || isLoadingAnalysis"
        @change="$emit('handleChangeDrives', $event)"
      >
        <template slot="selection" slot-scope="data">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-chip
                v-bind="data.attrs"
                :input-value="data.selected"
                close
                @click="data.select"
                @click:close="$emit('remove', data.item)"
                v-on="on"
              >
                <div>
                  <span v-if="data.item.collectorName" class="mr-1">[{{ data.item.collectorName }}]</span>
                  {{
                    maxText(data.item)
                      ? drivesName[data.item.name + ':\\'] || (data.item.provider || data.item.name) + ', '
                      : cropText(drivesName[data.item.name + ':\\'] || (data.item.provider || data.item.name) + ', ')
                  }}
                  {{ fileCountFormat(data.item.total_files) }}
                </div>
              </v-chip>
            </template>
            <div>
              <span v-if="data.item.collectorName" class="mr-1">[{{ data.item.collectorName }}]</span>
              {{ drivesName[data.item.name + ':\\'] || (data.item.provider || data.item.name) + ', ' }}
              {{ fileCountFormat(data.item.total_files) }}
            </div>
          </v-tooltip>
        </template>
        <template v-if="scan.drives.length" slot="append-item">
          <div v-if="isSelectAll" class="select-all" @click="$emit('selectAll', false)">Unselect All</div>
          <div v-else class="select-all" @click="$emit('selectAll', true)">Select All</div>
        </template>
        <template slot="item" slot-scope="data">
          <div class="scan-list--inner-item" @click="changeDrives(data)">
            <v-checkbox
              class="checkbox rounded-circle"
              color="#3ACA56"
              v-model="data.item.checked"
              @click="changeDrives(data)"
            >
            </v-checkbox>
            <div style="width: 100%">
              <div class="item-name">
                <span v-if="data.item.collectorName" class="mr-1">[{{ data.item.collectorName }}] </span
                >{{ drivesName[data.item.name + ':\\'] || data.item.name }}
              </div>
              <div class="item-stats d-flex">
                <span class="item-age">
                  {{ 'Scanned ' + ageFormat(data.item.completed_on) }}
                </span>
                <span class="file-count">
                  {{ fileCountFormat(data.item.total_files) + ' Files' }}
                </span>
              </div>
            </div>
          </div>
        </template>
      </v-select>
    </v-col>
    <v-col
      md="4"
      cols="12"
      v-if="selectedCollectors.length && discoveryType === 'stackedArea'"
    >
    <!-- Time series drives dropdown  -->
      <v-select
        v-model="selectedCollectorDrives"
        :items="getCollectorsDrives"
        class="scan-list"
        :label="selectedCollectorDrives.length ? 'Select Drives' : 'All'"
        attach
        chips
        multiple
        no-data-text="All"
        hide-details
        return-object
        :menu-props="{ offsetY: true }"
        :loading="isLoadingScans"
        :disabled="isLoadingScans || isLoadingAnalysis"
      >
        <template slot="selection" slot-scope="data">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-chip
                v-bind="data.attrs"
                :input-value="data.selected"
                close
                @click="data.select"
                @click:close="removeDrive(data)"
                v-on="on"
              >
                <div>
                  <span v-if="data.item" class="mr-1">[{{ data.item.cname }}] [{{ data.item.dname }}]</span>
                </div>
              </v-chip>
            </template>
            <div>
              <span v-if="data.item" class="mr-1">[{{ data.item.cname }}] [{{ data.item.dname }}]</span>
            </div>
          </v-tooltip>
        </template>
        <template v-if="getCollectorsDrives.length" slot="append-item">
          <div v-if="isDrivesSelect" class="select-all" @click="selectDrives(false)">Unselect All</div>
          <div v-else class="select-all" @click="selectDrives(true)">Select All</div>
        </template>
        <template slot="item" slot-scope="data">
          <div class="scan-list--inner-item">
            <v-checkbox
              class="checkbox rounded-circle"
              color="#3ACA56"
              :input-value="isDriveChecked(data.item)"
            >
            </v-checkbox>
            <div style="width: 100%">
              <div class="item-name">
                <span v-if="data.item" class="mr-1">[{{ data.item.cname }}] [{{ data.item.dname }}]</span>
              </div>
            </div>
          </div>
        </template>
      </v-select>
    </v-col>
    <v-col :md="actionCols" cols="12" class="d-flex flex-row">
      <div class="ml-2 mt-3">
        <img
          @click="show('showSunburst')"
          class="discovery-view-icon mr-3"
          :class="[
            discoveryType == 'discovery' && 'discovery-view-icon--active',
            isLoadingAnalysis && 'pointer-events-none',
          ]"
          :src="require('@/assets/icons/sunburst.svg')"
          alt=""
        />
        <img
          @click="show('showHistogram')"
          class="discovery-view-icon mr-3"
          :class="[
            discoveryType == 'histogram' && 'discovery-view-icon--active',
            isLoadingAnalysis && 'pointer-events-none',
          ]"
          :src="require('@/assets/icons/bar-chart.svg')"
          alt=""
        />
        <img
          v-if="showFuture"
          @click="show('showStackedArea'); selectCollectors(true)"
          class="discovery-view-icon"
          :class="[
            discoveryType == 'stackedArea' && 'discovery-view-icon--active',
            isLoadingAnalysis && 'pointer-events-none',
          ]"
          :src="require('@/assets/icons/stackedArea.svg')"
          alt=""
        />
      </div>
      <div class="ml-auto">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-on="on" text icon>
              <v-icon
                :color="theme.tabelEnteries"
                dark
                :class="'mr-auto material-icons-outlined'"
                v-bind="attrs"
                @click="$emit('confirmExportModal', actionExportDiscovery.modal)"
              >
                {{ actionExportDiscovery.icon }}
              </v-icon>
            </v-btn>
          </template>
          <span>{{ actionExportDiscovery.name }}</span>
        </v-tooltip>
        <v-tooltip v-if="discoveryType == 'discovery'" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-on="on" text icon>
              <v-icon
                :color="theme.tabelEnteries"
                dark
                :class="'mr-auto material-icons-outlined'"
                v-bind="attrs"
                @click="$parent.$emit('downloadSunburstCSV', {})"
              >
                mdi-progress-download
              </v-icon>
            </v-btn>
          </template>
          <span>Export Sunburst data</span>
        </v-tooltip>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import moment from 'moment'
import collectorMixin from '@/mixins/collectorMixin'
import { numberWithCommas } from '@/utils/main_helper'

export default {
  name: 'ScanList',
  mixins: [collectorMixin],
  props: [
    'list',
    'scans',
    'compare-id',
    'compare-to-id',
    'loading',
    'compareMode',
    'countSum',
    'totalSize',
    'discoveryType',
    'selectedScan',
    'selectedDrives',
    'scan',
    'drivesName',
    'isSelectAll',
    'showFuture'
  ],
  data () {
    return {
      selectedCollectors: [],
      selectedCollectorDrives: [],
      actionExportDiscovery: {
        name: 'click to export discovery',
        icon: 'file_download',
        modal: {
          text: 'Would you like to export discovery',
          name: undefined,
          argument: 'key'
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      currentOrganization: 'currentOrganization',
      colorPalette: 'colorPaletteServices/theme',
      theme: 'colorPaletteServices/theme'
    }),
    ...mapState('discoveryServices', ['isLoadingScans', 'isLoadingAnalysis']),
    compareToList () {
      return this.list
    },
    isCollectorsSelect () {
      return this.collectors.length === this.selectedCollectors.length
    },
    isDrivesSelect () {
      return this.getCollectorsDrives.length === this.selectedCollectorDrives.length
    },
    getSortedCollectors () {
      const collectors = [...this.collectors]
      return collectors.sort((a, b) => a.name.localeCompare(b.name))
    },
    getCollectorsDrives () {
      const drives = []
      const collectors = this.getSortedCollectors.filter(collector => this.selectedCollectors.includes(collector.entity_id))
      collectors.forEach((collector) => {
        collector.drives.sort((a, b) => a.localeCompare(b)).forEach(drive => {
          drives.push({ collectorId: collector.entity_id, cname: collector.name, dname: this.getDriveName(collector, drive) })
        })
      })
      return drives
    },
    actionCols () {
      return this.selectedScan && this.selectedScan.entity_id && this.selectedScan.entity_id === 'last_24_hours' && !this.getCollectorsDrives.length ? 8 : 4
    }
  },
  methods: {
    onScanSelect (item, compare) {
      this.$emit('onSelect', { item, compare })
    },
    handleOptionClick (event, item, compare) {
      this.onScanSelect(item, compare)
    },
    getFormattedDateTime (scanDate) {
      return moment(scanDate, 'YYYY-MM-DD hh:mm:ss A').format('YYYY-MM-DD hh:mm A')
    },
    maxText (item) {
      const collectorName = item.collectorName?.length || 0
      const driveName = this.drivesName[item.name + ':\\']
        ? this.drivesName[item.name + ':\\'].length
        : item.name.length
      const totalFiles = (item.total_files + '').length
      return collectorName + driveName + totalFiles <= 32
    },
    cropText (text) {
      if (text.length > 10) {
        return text.substring(0, 8) + '...'
      }
    },
    fileCountFormat (n) {
      if (n <= 1e3) return n
      if (n >= 1e3 && n < 1e6) return +(n / 1e3).toFixed(1) + 'k'
      if (n >= 1e6 && n < 1e9) return +(n / 1e6).toFixed(1) + 'm'
      if (n >= 1e9 && n < 1e12) return +(n / 1e9).toFixed(1) + 'b'
      if (n >= 1e12) return +(n / 1e12).toFixed(1) + 't'
    },
    changeDrives (item) {
      item.item.checked = !item.item.checked
    },
    ageFormat (date) {
      const time = moment(date, 'YYYY-MM-DD hh:mm A').valueOf()
      const currentTime = moment().valueOf()
      const diffTime = Math.abs(currentTime - time)
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
      if (diffDays < 7) {
        return diffDays + ' days ago'
      } else if (diffDays >= 7 && diffDays < 31) {
        return Math.ceil(diffDays / 7) + ' weeks ago'
      } else if (diffDays >= 31 && diffDays < 365) {
        return Math.ceil(diffDays / 30) + ' months ago'
      } else if (diffDays >= 365) {
        return Math.ceil(diffDays / 365) + ' years ago'
      }
    },
    isCollectorChecked (item) {
      return this.selectedCollectors.includes(item.entity_id)
    },
    isDriveChecked (item) {
      const res = this.selectedCollectorDrives.filter(i => i.collectorId === item.collectorId && i.dname === item.dname)
      return !!res.length
    },
    show (name) {
      this.selectedCollectors = []
      this.selectedCollectorDrives = []
      this.$emit(name)
    },
    removeCollector (item) {
      const index = this.selectedCollectors.indexOf(item.entity_id)
      index !== -1 && this.selectedCollectors.splice(index, 1)
    },
    removeDrive (data) {
      this.selectedCollectorDrives.splice(data.index, 1)
    },
    selectCollectors (status) {
      this.selectedCollectors = status ? this.getSortedCollectors.map(collector => collector.entity_id) : []
      if (!status) this.selectedCollectorDrives = []
    },
    selectDrives (status) {
      this.selectedCollectorDrives = status ? this.getCollectorsDrives : []
    },
    getSelectedDrives (collectorId) {
      const drives = []
      this.selectedCollectorDrives.forEach(item => {
        if (item.collectorId == collectorId) drives.push(this.trimDriveName(item.dname))
      })
      return drives.length ? drives : []
    },
    trimDriveName (name) {
      return name.includes(':') ? name.split(':')[0] : name
    },
    loadTimeSeries () {
      const collectors = {}
      this.selectedCollectors.map(collectorId => {
        collectors[collectorId] = this.getSelectedDrives(collectorId)
      })
      this.$store.dispatch('discoveryServices/timeSeries', { organization_id: this.currentOrganization.entity_id, collectors })
    },
    getDriveName (collector, drive) {
      return (collector.drivesName && collector.drivesName[drive]) ? collector.drivesName[drive] : drive
    },
    format (num) { return ((num) ? numberWithCommas(num) : '-') }
  },
  watch: {
    collectors () {
      this.selectCollectors(true)
    },
    selectedCollectors () {
      this.selectedCollectorDrives = [...this.getCollectorsDrives]
    },
    selectedCollectorDrives () {
      this.showFuture && this.loadTimeSeries()
    }
  }
}
</script>

<style lang="scss" scoped>
.active-white-bg {
  background: #c34d90 !important;
}
.v-select-list {
  outline: none;
}
.v-btn.v-btn--depressed.btn-gradient.compare-btn {
  min-height: 48px;
  &:disabled {
    background: rgba(255, 255, 255, 0.09) !important;
    background-color: rgba(255, 255, 255, 0.09) !important;
  }
}
::v-deep {
  .scan-list {
    .v-list-item {
      padding: 0px 5px;
    }
    .v-list-item__title {
      padding-left: 10px;
    }
    .primary--text {
      color: $black-color !important;
    }

    .v-input__slot {
      background: none !important;
      box-shadow: none !important;
    }

    .v-label--active {
      transform: translateY(-20px) scale(1) !important;
    }
    label {
      top: 0;
    }
    .v-select__selections {
      padding-left: 10px;
      font-size: 14px;
      color: $black-color !important;
      min-height: 41px !important;
    }
    .select-all {
      color: $primary-color;
      margin-left: 20px;
      font-weight: bold;
      font-size: 16px;
      cursor: pointer;
      margin-top: 15px;
    }
  }

  .checkbox {
    .v-input__slot {
      background: none !important;
    }
  }
  .v-text-field__details {
    margin-bottom: 0px !important;
  }
}

::v-deep {
  .scan-list {
    .v-list-item--link {
      min-height: 0 !important;
      padding: 0 !important;
    }
    color: $card-text-color;
    &--item {
      display: flex;
      align-items: center;
      height: 48px;
      font-size: 14px;
      width: 100%;
      padding: 0 5px;
      justify-content: space-between;
      color: $card-text-color;
      width: 100%;
      &.disable {
        display: none;
        cursor: not-allowed;
        background: #eee !important;
      }
    }
    &--inner-item {
      display: flex;
      align-items: center;
      height: 48px;
      font-size: 14px;
      width: 100%;
      padding: 0 5px;
      color: $primary-color;
      .item-stats {
        color: $card-text-color;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
      }
      &.disable {
        display: none;
        cursor: not-allowed;
        background: #eee !important;
      }
    }
    .v-list-item--active {
      background: #eee !important;
      .item-name {
        color: $primary-color;
      }
    }
  }
}

.pointer-events-none {
  pointer-events: none;
}

.v-select-list {
  outline: none;
}
.item-name {
  font-weight: bold;
  font-size: 16px;
}
.item-age {
  font-size: 14px;
}
.file-count {
  font-weight: bold;
  font-size: 14px;
}
.checkbox {
  .v-input__slot {
    background: none !important;
  }
}
.v-text-field__details {
  margin-bottom: 0px !important;
}

@media only screen and (max-width: 1370px) {
  .item-name {
    font-weight: bold;
    font-size: 14px;
  }
  .item-age {
    font-size: 11px;
  }
  .file-count {
    font-weight: bold;
    font-size: 11px;
  }
}
</style>
